import React from 'react'
import styled from 'react-emotion'

import Button from '../buttons/Button'

import NavDropdown from './NavDropdown'

const Nav = styled.ul`
  display: flex;
  align-items: center;
  li {
    display: inline;
  }
`

const Navigation = (props) => {
  return (
    <Nav>
      {props.links.map((link, idx) => {
        if (link.links) {
          return (
            <li key={idx}>
              <NavDropdown key={link.label} nav={link} />
            </li>
          )
        } 
        else {
          return (
            <li key={idx}>
              <Button anchor navLink title={link.label} {...link}>{link.label}</Button>
            </li>
          )
        }
      })}
    </Nav>
  )
}
 
export default Navigation;


// WEBPACK FOOTER //
// ./src/components/header/Navigation.js